import React from "react"
import api from "src/api"
import { getPoints, getPromotionCategories } from "src/utils"
import { buildSearchFilter } from "src/utils/build-search-filter"

const SEARCH_FIELDS = ["id", "name"]

export function useGetData() {
  const [dataPromotions, setDataPromotions] = React.useState([])
  const [dataPromotionsColumns, setDataPromotionsColumns] = React.useState([])

  const [cityOptions, setCityOptions] = React.useState([])
  const [categoryOptions, setCategoryOptions] = React.useState([])

  const [pagination, setPagination] = React.useState(null)
  const [appliedFilters, setAppliedFilters] = React.useState("")
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    getItems()
    getPointsOptions()
    getCategoryOptions()
  }, [])

  async function getItems(page = 1, countOnPage = 20, filters = "") {
    setIsLoading(true)
    try {
      const { data } = await api.get(`promotions?page=${page}&countOnPage=${countOnPage}${filters}`)
      setPagination({
        current: data.pagination.currentPage,
        pageSize: data.pagination.countOnPage,
        total: data.pagination.total,
      })
      updateItems(data.items)

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  function updateItems(items) {
    const newData = getFormattedItems(items)
    setDataPromotionsColumns(newData)
    setDataPromotions(items)
  }

  async function getPointsOptions() {
    const data = await getPoints()

    const options = data.map((item) => ({
      label: item.name,
      value: item.id,
    }))
    setCityOptions(options)
  }

  async function getCategoryOptions() {
    const data = await getPromotionCategories()

    const options = data.reduce((acc, item) => {
      if (!item.isActive) {
        return acc
      }

      const searchName = item?.name?.find((el) => el.language === "ru")
      return [
        ...acc,
        {
          label: searchName.content,
          value: item.id,
        },
      ]
    }, [])
    setCategoryOptions(options)
  }

  function handleTableChange(pagination) {
    getItems(pagination.current, pagination.pageSize, appliedFilters)
  }

  function handleSearchTable(value) {
    const filters = buildSearchFilter(value, SEARCH_FIELDS)
    setAppliedFilters(filters)
    getItems(1, 20, filters)
  }

  function getFormattedItems(items) {
    const newItems = items.map((item) => {
      const category = item.promotionCategory.name
      const name = item.name
      const description = item.description
      const cityNames = item.points.map((point) => point.name)

      return {
        key: item.id,
        id: item.id,
        isActive: item.isActive,
        category: category.find((el) => el.language === "ru").content,
        name: name.find((el) => el.language === "ru").content,
        description: description.find((el) => el.language === "ru").content,
        points: cityNames.join(", "),
      }
    })

    return newItems
  }

  return {
    dataPromotions,
    dataPromotionsColumns,
    pagination,
    isLoading,
    handleTableChange,
    handleSearchTable,
    refetch: () => getItems(pagination?.current || 1, pagination?.pageSize || 20, appliedFilters),
    options: { cityOptions, categoryOptions },
  }
}
